import React from "react";
import { ToggleButtonGroup, ToggleButton } from "@mui/material";

const RANGES = [
  { label: "7d", value: "7" },
  { label: "30d", value: "30" },
  { label: "90d", value: "90" },
  { label: "All", value: "all" },
];

const DateRangeToggle = ({ value = "30", onChange }) => (
  <ToggleButtonGroup value={value} exclusive onChange={(e, v) => v && onChange(v)} size="small">
    {RANGES.map((r) => (
      <ToggleButton key={r.value} value={r.value}
        sx={{ textTransform: "none", fontWeight: 600, fontSize: 12, px: 1.5, color: value === r.value ? "#6366f1" : "#64748b", borderColor: "#e2e8f0", "&.Mui-selected": { bgcolor: "#6366f112", color: "#6366f1" } }}>
        {r.label}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);

export default DateRangeToggle;
